"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapStoreData = void 0;
var utils_1 = require("../utils");
var consts_1 = require("../consts");
var mapStoreData = function (store) {
    var _a, _b, _c;
    var mappedStoreData = {
        storecountry: (0, utils_1.removeSpecialCharacters)(((store === null || store === void 0 ? void 0 : store.storecountry) || ((_a = window.pmistore) === null || _a === void 0 ? void 0 : _a.country)) || consts_1.NOT_AVAILABLE),
        storeid: ((store === null || store === void 0 ? void 0 : store.storeid) || ((_b = window.pmistore) === null || _b === void 0 ? void 0 : _b.storeid)) || consts_1.NOT_AVAILABLE,
        storecurrency: (0, utils_1.removeSpecialCharacters)(((store === null || store === void 0 ? void 0 : store.storecurrency) || ((_c = window.pmistore) === null || _c === void 0 ? void 0 : _c.currency)) || consts_1.NOT_AVAILABLE),
    };
    return mappedStoreData;
};
exports.mapStoreData = mapStoreData;
exports.default = exports.mapStoreData;
